import { LevelPopupSideMenuLayout } from 'Layouts/LevelPopup/LevelPopupSideMenuLayout';
import GameObject, { GameObjectEvent } from 'GameObject/GameObject';
import { applyDefaultButtonAnimation } from '../../UIHelper';
import { track } from 'Utility/Tracking/Track';
import { TSocialActionType } from 'Utility/Tracking/DataSet/Transaction';
import Game from 'Game';
import { GameActions } from 'State/Game/GameActions';
import { ContextType } from 'State/Game/ContextType';
import FriendHubScroll from 'Prototype/UI/Popup/FriendHub/FriendHubScroll';
import { IScoreEntry } from 'Utility/SDK/Drivers/IScoreEntry';
import Renderable from 'Component/Renderable';
import TransformComponent from 'Component/Transform';
import { SideFriendItem } from './SideFriendItem';
import { Anim } from 'System/Animation/AnimationHelper';
import { Easing } from '@tweenjs/tween.js';
import Element from 'Prototype/UI/Element';
import { Leaderboard } from '../../LeaderboardHelper';
import SpriteComponent from 'Component/Render/Sprite';
import { EventStateHelper } from 'State/Events/EventStateHelper';
import { PopupID } from 'State/UI/PopupID';
import { WorldDataHelper } from 'Utility/WorldDataHelper';
import { EventCharacterIDs, isCurrentEvent } from 'Constants/Events/CurrentEvent';
const { getEventLayout, getEvent } = EventStateHelper;
type SideMenuProps = {
    levelNumber: number;
};

export class SideMenu {
    private readonly layout: any;
    private scrollArea: Element;
    private interval: () => void | null = null;
    private items: SideFriendItem[] = [];

    constructor(props: SideMenuProps) {
        const state = Game.store.getState();
        const isEventActive = isCurrentEvent(getEvent(state, PopupID.LEVEL_POPUP_SIDE_MENU));

        this.layout = getEventLayout(state, PopupID.LEVEL_POPUP_SIDE_MENU) ?? new LevelPopupSideMenuLayout();
        this.layout.root.getComponent(Renderable).alpha = 0;
        this.createScrollArea();

        this.layout.inviteButton.on(GameObjectEvent.SELECTED, this.handleInviteClick);
        applyDefaultButtonAnimation(this.layout.inviteButton);

        this.interval = Game.ticker.setInterval(this.updateFriendItems.bind(this), 1000);

        Game.sdk
            .getFriendScores(Leaderboard.LEVEL_SCORE, String(props.levelNumber))
            .then(this.fillFriendsList.bind(this))
            .catch(e => {
                console.log('Friend scores failed to load', e);
                this.fillFriendsList([]);
            });

        if (WorldDataHelper.isHardLevel(props.levelNumber)) {
            this.layout.bg.getComponent(SpriteComponent).texture = isEventActive
                ? EventCharacterIDs.hardTopList
                : 'top_list_hard';
        }
    }

    public onShow() {
        // TODO: Remove this function once Event Layouts are no longer keyed by PopupIDs requiring this arbitrary object to contain the `onShow` method.
        // If this method is removed TS will fail to compile.
    }

    public get root(): GameObject {
        return this.layout.root;
    }

    public handleInviteClick(): void {
        track('socialActionType', TSocialActionType.INVITE);
        GameActions.setContext(ContextType.INVITE_FRIEND, 'TopList');
    }

    private createScrollArea() {
        this.scrollArea = GameObject.Instantiate(FriendHubScroll, {
            layout: {
                anchors: [0, 0, 0, 0],
                offsets: [0, 0, 0, 0],
                pivot: [0, 0],
                constrains: {
                    heightMin: 412,
                    heightMax: 412,
                    widthMin: 400,
                    widthMax: 400,
                },
            },
        });
        this.layout.friendsContainer.addChild(this.scrollArea);
    }

    public fillFriendsList(friendsData?: IScoreEntry[]) {
        if (!this.scrollArea || this.scrollArea.destroyed || !this.scrollArea.hasComponent<Renderable>(Renderable))
            return;

        const hasNoFriends: boolean = !friendsData || friendsData.length === 0;
        (this.layout.friendsContainer as GameObject).getComponent<Renderable>(Renderable).visible = !hasNoFriends;
        (this.layout.sideTitleText as GameObject).getComponent<Renderable>(Renderable).visible = !hasNoFriends;
        (this.layout.noFriendsContainer as GameObject).getComponent(Renderable).visible = hasNoFriends;

        this.layout.root.getComponent(TransformComponent).x = -400;
        Anim(this.layout.root, { x: 0, alpha: 1, duration: 500, delay: 300, easing: Easing.Sinusoidal.Out });

        if (!friendsData) return;

        for (let i = 0; i < friendsData.length; i++) {
            const item = GameObject.Instantiate(SideFriendItem, { playerData: friendsData[i], index: i });
            this.scrollArea.addChild(item);
            this.items.push(item);
        }

        this.scrollArea.container.resize(0, 0);
    }

    public destroy() {
        Game.ticker.clearInterval(this.interval);
        this.interval = null;
    }

    private updateFriendItems(): void {
        this.items.forEach(item => {
            item.updateTimers();
        });
    }
}
